import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-konservation',
  templateUrl: './konservation.component.html',
  styleUrls: ['./konservation.component.scss']
})
export class KonservationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
